import { render } from "./RequestContent.vue?vue&type=template&id=31b57954"
import script from "./RequestContent.vue?vue&type=script&lang=js"
export * from "./RequestContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__